import React from 'react'
import { useWindowDimensions, ScrollView, View, Image } from 'react-native'
import { Text, Button } from '@ui-kitten/components'
import tailwind from 'tailwind-rn'
import { useNavigation } from '@react-navigation/native'
import HeaderInterno from '../components/HeaderInterno'
import FooterInterno from '../components/FooterInterno'
import FooterMenu from '../components/FooterMenu'
import { useMediaQuery } from 'react-responsive'
import RenderHtml from 'react-native-render-html'
import YoutubePlayer from "react-native-youtube-iframe"

import Colors from '../constants/Colors'

import { SafeAreaView } from 'react-native-safe-area-context'

const source1 = {
  html: `
<p style='text-align:left; font-size: large; font-weight: bold; color: #5c0b78'>Em Vitória da Conquista, Salvador e Feira de Santana</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>A Caravana do Growth são encontros presenciais em Vitória da Conquista, Salvador e Feira de Santana onde será apresentado de forma intensiva e objetiva tudo o que aconteceu nos dois primeiros ciclos do Programa e deixar seu negócio pronto para decolar na próxima fase.</p>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>O Growth, método idealizado e testado no Vale do Silício, pelas Startups e algumas das empresas que mais crescem no mundo, já está transformando negócios de diferentes portes e mercados, com resultados incríveis de crescimento de vendas e lucro. Resultados com conquista de novos clientes, reativação de relacionamentos comerciais e aumento de margens de lucro são apenas alguns dos indicadores que o Programa ajudou a gerar nos primeiros meses de operação.</p>
<ul>
<li>Vitória da Conquista: <strong>09/08 19:00 - Senac Vitória da Conquista - <span style='color:red'>INSCRIÇÕES ENCERRADAS</span></strong></li>
<li>Salvador: <strong>10/08 18h - Espaço Mário Cravo, na Casa do Comércio – 3º Andar - <span style='color:red'>INSCRIÇÕES ENCERRADAS</span></strong></li>
<li>Feira de Santana: <strong>11/08 18h30 - Hotel Ibis Feira de Santana - <span style='color:red'>INSCRIÇÕES ENCERRADAS</span></strong></li>
</ul>
<p style='text-align:left; font-size: smaller; line-height: 18px;'>Inscreva-se gratuitamente pelos botões abaixo e aproveite essa chance de acelerar sua empresa e seus negócios.</p>
`
};


export default function Caravana() {

  const isLargeScreen = useMediaQuery({minDeviceWidth: 440})
  const windowWidth = isLargeScreen ? 800 : useWindowDimensions().width
  const windowHeight = useWindowDimensions().height
  const navigation = useNavigation()

  const _goFormVit = () => {
    navigation.navigate('FormRDCaravanaVit', {})
//    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSclP-vGIjG0gj9MtWVaWq21AAcHxuBhAVETRdPLAacHsgdYCA/viewform?vc=0&c=0&w=1&flr=0')
  }

  const _goFormSsa = () => {
    navigation.navigate('FormRDCaravanaSsa', {type: 'ssa'})
//    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSclP-vGIjG0gj9MtWVaWq21AAcHxuBhAVETRdPLAacHsgdYCA/viewform?vc=0&c=0&w=1&flr=0')
  }

  const _goFormFeira = () => {
    navigation.navigate('FormRDCaravanaFeira', {type: 'feira'})
//    Linking.openURL('https://docs.google.com/forms/d/e/1FAIpQLSclP-vGIjG0gj9MtWVaWq21AAcHxuBhAVETRdPLAacHsgdYCA/viewform?vc=0&c=0&w=1&flr=0')
  }

      return (
        <SafeAreaView style={{flex:1, backgroundColor: "#ece7e7"}}>
          <HeaderInterno title="CARAVANA GROWTH" subtitle="Crescimento Acelerado" />
          <ScrollView style={{height: windowHeight, width: windowWidth}}>
            <View style={[tailwind('bg-white mx-7 mt-5 mb-40'), { shadowColor: '#000', shadowOffset: {width: 0, height: 4}, shadowOpacity: 0.5, shadowRadius: 4.85, borderRadius: 20 }]}>
            <View style={[tailwind('mb-10'), {marginTop: isLargeScreen ? 110 : 150}]}>
                  <>
                <View style={tailwind('mx-5')}>
                  <RenderHtml
                    contentWidth={100}
                    source={source1}
                  />
                </View>  
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goFormVit} disabled><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE - VITÓRIA DA CONQUISTA</Text></Button>
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goFormFeira} disabled><Text style={{color: Colors.roxo, fontWeight: 'bold'}} >INSCREVA-SE - FEIRA DE SANTANA</Text></Button>
                <Button nativeID="btn" size="large" style={[tailwind('self-center'), {marginTop: 10, marginBottom: 10, borderRadius: 20, borderColor: Colors.laranja_forte, backgroundColor: Colors.laranja_forte, width: windowWidth/2}]} onPress={_goFormSsa} disabled><Text style={{color: Colors.roxo, fontWeight: 'bold'}}>INSCREVA-SE - SALVADOR</Text></Button>
                </>
              </View>
            </View>
            {!isLargeScreen && <FooterInterno />}
          </ScrollView>
          <FooterMenu />
        </SafeAreaView>
      )


}
